import { render, staticRenderFns } from "./PainelRolante.vue?vue&type=template&id=c04418cc&scoped=true"
import script from "./PainelRolante.vue?vue&type=script&lang=js"
export * from "./PainelRolante.vue?vue&type=script&lang=js"
import style0 from "./PainelRolante.vue?vue&type=style&index=0&id=c04418cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04418cc",
  null
  
)

export default component.exports